import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import ListAltIcon from '@mui/icons-material/ListAlt';

import { BoxBorder, HStack } from './Base';
import { ManageList } from '../config/sports';
import { useLocales } from 'locales';
import { useAuthContext } from 'hooks';

export const ManageHead = (props: any) => {
  const { title, idx }: any = props;
  const { t } = useLocales();

  return (
    <Box sx={{ bgcolor: (theme) => theme.palette.background.paper }}>
      <Stack direction='row' alignItems='center' justifyContent='space-between' p={2} >
        <HStack>
          {
            (() => {
              if (idx !== undefined) {
                return ManageList[idx].icon
              } else {
                return (
                  <ListAltIcon sx={{ fontSize: (theme) => theme.spacing(6) }} color='error' />
                )
              }
            })()
          }
          <Typography
            variant='h5'
            noWrap
            component='h5'
            ml={1}
          >
            {t(title)}
          </Typography>
        </HStack>
      </Stack>
    </Box>
  )
}

export const AdminManageList = (props: any) => {
  const { setTitle }: any = props;
  const { t } = useLocales();
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState(0);
  const { user } = useAuthContext();

  const clickHandl = (item: { name: string, url: string }, idx: number) => {
    navigate(item.url);
    setActive(idx);
    setTitle({ name: item.name, idx });
  }

  useEffect(() => {
    const path = location.pathname.split('/');
    const idx = ManageList.findIndex(a => a.url === path[path.length - 1])
    if (idx > -1) {
      setActive(idx);
      setTitle({ name: ManageList[idx].name, idx });
    } else {
      setActive(0);
      setTitle({ name: 'Users', idx: 0 });
    }
  }, [setTitle, location]);

  return (
    <Stack direction={{ sm: 'row', xm: 'column' }} sx={{ justifyContent: 'flex-start' }}>
      {
      ManageList.map((item: { name: string, url: string }, idx: number) => {
      // Show 'players' only for admin users and if REACT_APP_SHOW_ADMIN_PLAYERS_TAB is true
      if (
        item.url === 'players' &&
        (user?.role !== 'admin' || process.env.REACT_APP_SHOW_ADMIN_PLAYERS_TAB !== 'true')
      ) {
        return null;
      }
      // Show 'announcements' only for admin users and if REACT_APP_ANNOUNCEMENTS_API is true
      if (
        item.url === 'announcements' &&
        (user?.role !== 'admin' || process.env.REACT_APP_ANNOUNCEMENTS_API !== 'true')
      ) {
        return null;
      }
      // Show 'deposits' only if REACT_APP_SHOW_DEPOSITS_TAB is true
      if (
        item.url === 'deposits' &&
        process.env.REACT_APP_SHOW_DEPOSITS_TAB !== 'true'
      ) {
        return null;
      }
      return (
        <BoxBorder key={idx}
        sx={{
          mr: { sm: 1, xs: 0 },
          position: 'relative',
          transition: 'top 0.3s',
          top: active === idx ? '3px' : 0,
          borderBottom: active === idx ? '0px' : 'none',
          bgcolor: (theme) => theme.palette.background.paper,
        }}
        >
        <Button
          onClick={() => clickHandl(item, idx)}
          sx={{
          px: 2,
          width: '100%',
          borderRadius: 0,
          color: active === idx ? 'error.main' : '#ffffff',
          borderColor: active === idx ? (theme) => theme.palette.background.paper : (theme) => theme.palette.secondary.light,
          [`&:hover`]: {
            color: 'error.main',
          }
          }}
        >
          {t(item.name)}
        </Button>
        </BoxBorder>
      );
      })
      }
    </Stack>
  )
}